import { forwardRef } from "react";
import {
  Tooltip as MuiTooltip,
  TooltipProps as MUITooltipProps,
} from "@mui/material";

export type TTooltipProps = MUITooltipProps & { disabled?: boolean };

const Tooltip = forwardRef(
  ({ className, arrow, disabled, ...props }: TTooltipProps, ref) => {
    return disabled ? (
      props.children
    ) : (
      <MuiTooltip
        {...props}
        arrow={arrow ?? true}
        classes={{ popper: className }}
        ref={ref}
      />
    );
  },
);

export default Tooltip;
